.button_panel {
  margin-bottom: 20px;
}

.footer {
  margin-top: 20px;
  margin-bottom: 20px;
}
